import React, { useContext, useEffect, useMemo } from "react";
import { createT, setRuntimeLocale } from "./runtime";
import { DEFAULT_LOCALE } from "./config";
import { saveLocale } from "./detect";

const LocaleContext = React.createContext();

// route: "home" | "date" | "privacy"
export function LocaleProvider({ locale, messages, route, children }) {
  setRuntimeLocale(locale, messages);

  const value = useMemo(
    () => ({ locale, messages, route, t: createT(messages) }),
    [locale, messages, route]
  );

  // Visiting /fr, /de or /es counts as choosing that language, so the
  // backend's redirects to / (after login, register, logout) send the player
  // back to it
  useEffect(() => {
    if (locale !== DEFAULT_LOCALE) {
      saveLocale(locale);
    }
  }, [locale]);

  return (
    <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
  );
}

export function useLocale() {
  return useContext(LocaleContext);
}

export function useT() {
  return useContext(LocaleContext).t;
}
